<template>
  <div class="wrapper">
    <h1>Opdracht informatie</h1>

    <div class="bottom">
      <div class="left">
        <h3>Details</h3>
        <DetailItem v-if="selectedOpdracht.inkoopNummer" :tag="true" identifier="inkoopnummer" :value="selectedOpdracht.inkoopNummer" />
        <DetailItem identifier="provincie" :value="selectedOpdracht.opdrachtgever.adres.provincie" />
        <DetailItem identifier="bedrijfsnaam" :value="selectedOpdracht.opdrachtgever.bedrijfsnaam" />
        <DetailItem identifier="discipline" :value="selectedOpdracht.aanvraag.discipline" />
        <DetailItem identifier="werkplek" :value="selectedOpdracht.aanvraag.werkplek" />
        <DetailItem identifier="tekenprogramma" :value="selectedOpdracht.aanvraag.tekenprogramma" />
      </div>
      <div class="lineDivider"></div>
      <div class="right">
        <h3>Omschrijving</h3>
        <button @click="editMode = !editMode">bewerk</button>
        <p v-if="!editMode" class="omschrijving">{{ selectedOpdracht.aanvraag.omschrijving }}</p>
        <div>
          <a class="downloadFile" v-if="selectedOpdracht.voorbeeldBestandUrl" :href="selectedOpdracht.voorbeeldBestandUrl" target="_blank">
            <span><i class="fas fa-file-download"></i> Download aangeleverde documenten</span>
          </a>
          <div class="downloadFile light" v-else>
            <span> Er zijn nog geen aangeleverde documenten</span>
          </div>

          <form v-if="editMode" @submit.prevent="submitEditContactDetailsForm()">
            <textarea style="width: 100%; height: 140px;" v-model="editable.aanvraag.omschrijving"></textarea>
            <br />
            <br />

            <div style="display: flex">
              <div style="display: flex; flex-direction: column;">
                <div style="display: flex">
                  <input type="text" v-model="editable.opdrachtgever.naam.voornaam" placeholder="voornaam" />
                  <input type="text" v-model="editable.opdrachtgever.naam.achternaam" placeholder="achternaam" />
                </div>
                <input type="text" v-model="editable.opdrachtgever.adres.straat" placeholder="straat" />
                <input type="text" v-model="editable.opdrachtgever.adres.postcode" placeholder="postcode" />
                <input type="text" v-model="editable.opdrachtgever.adres.plaats" placeholder="plaats" />
              </div>
              <div style="display: flex; flex-direction: column; margin-left: 10px; width: 100%;">
                <input type="text" v-model="editable.opdrachtgever.telefoonnummer" placeholder="telefoon" />
                <input type="text" v-model="editable.opdrachtgever.email" placeholder="email" />
                <input type="text" v-model="editable.opdrachtgever.administratie.kvkNummer" placeholder="kvk nummer" />
              </div>
            </div>

            <button :disabled="JSON.stringify(editable) === JSON.stringify(selectedOpdracht)" style="width: 100%; margin-top: 10px;" type="submit">Sla wijzigingen op</button>
          </form>
          <div v-if="!editMode" class="contactWrapper">
            <div class="left1">
              <CopySlot class="item1" :valueToCopy="`${selectedOpdracht.opdrachtgever.naam.voornaam} ${selectedOpdracht.opdrachtgever.naam.achternaam}`">
                <span class="light">Contact</span>
                <span>{{ selectedOpdracht.opdrachtgever.naam.voornaam }} {{ selectedOpdracht.opdrachtgever.naam.achternaam }}</span>
              </CopySlot>
              <CopySlot class="item1" :valueToCopy="`${selectedOpdracht.opdrachtgever.adres.straat}`">
                <span class="light">Straat</span>
                <span>{{ selectedOpdracht.opdrachtgever.adres.straat || "Onbekend" }}</span>
              </CopySlot>
              <CopySlot class="item1" :valueToCopy="`${selectedOpdracht.opdrachtgever.adres.postcode || 'Onbekend'}`">
                <span class="light">Postcode</span>
                <span>{{ selectedOpdracht.opdrachtgever.adres.postcode || "Onbekend" }}</span>
              </CopySlot>
              <CopySlot class="item1" :valueToCopy="`${selectedOpdracht.opdrachtgever.adres.plaats || 'Onbekend'}`">
                <span class="light">Plaats</span>
                <span>{{ selectedOpdracht.opdrachtgever.adres.plaats || "Onbekend" }}</span>
              </CopySlot>
            </div>
            <div class="right1">
              <CopySlot class="item1" :valueToCopy="`${selectedOpdracht.opdrachtgever.telefoon}`">
                <span class="light">Telefoon</span>
                <span>{{ selectedOpdracht.opdrachtgever.telefoonnummer || "onbekend" }}</span>
              </CopySlot>
              <CopySlot class="item1" :valueToCopy="`${selectedOpdracht.opdrachtgever.email}`">
                <span class="light">Email</span>
                <span>{{ selectedOpdracht.opdrachtgever.email }}</span>
              </CopySlot>
              <CopySlot class="item1" :valueToCopy="`${selectedOpdracht.opdrachtgever.kvkNummer || 'Onbekend'}`">
                <span class="light">KVk</span>
                <span>{{ selectedOpdracht.opdrachtgever.administratie.kvkNummer || "Onbekend" }}</span>
              </CopySlot>
              <CopySlot class="item1" :valueToCopy="`${selectedOpdracht.opdrachtnummer}`">
                <span class="light">Dbt. nr.</span>
                <span>20.<span v-for="(x, index) in 4 - `${dbtNummer}`.length" :key="index">0</span>{{ dbtNummer }}</span>
              </CopySlot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CopySlot from "@/components/v2/interactions/CopySlot"
import DetailItem from "./DetailItem"
import { ref } from "@vue/reactivity"
import { watchEffect } from "vue"
import { db } from "../../../../firebase"

export default {
  props: ["selectedOpdracht", "opdrachtStatus", "isPartnerOpdracht"],
  components: { DetailItem, CopySlot },
  setup(props) {
    const dbtNummer = ref("")

    const getNummer = async id => {
      fetch(`https://us-central1-cdt-dev-94ea4.cloudfunctions.net/debiteuren-api/getdebiteurnummer?id=${id}`).then(data => {
        data.json().then(result => {
          dbtNummer.value = result.debiteurNummer
        })
      })
    }
    getNummer(props.selectedOpdracht.opdrachtgever.bedrijfsnaam)

    const editMode = ref(false)

    const editable = ref()

    watchEffect(() => {
      editable.value = JSON.parse(JSON.stringify(props.selectedOpdracht))
    })

    const submitEditContactDetailsForm = async () => {
      try {
        const docRef = db.collection("opdrachten").doc(props.selectedOpdracht.id)

        await docRef.update({ opdrachtgever: editable.value.opdrachtgever, aanvraag: editable.value.aanvraag })

        editMode.value = false
      } catch (error) {
        alert("Er is iets fout gegaan bij het updaten")
      }
    }

    return {
      dbtNummer,
      editMode,
      editable,
      submitEditContactDetailsForm
    }
  }
}
</script>

<style lang="sass" scoped>


.downloadFile
  display: flex
  // margin-top: 20px
  font-size: 14px
  color: black
  text-decoration: none
  letter-spacing: 0.01em
  background-color: rgba(0, 0, 0, 0.04)
  align-items: center
  justify-content: center
  padding: 10px
  border-radius: 4px
  cursor: pointer
  border: 1px solid rgba(0, 0, 0, 0.032)
  transition: .25s
  display: none !important

  &:hover
    background-color: rgba(0, 0, 0, 0.07)
    color: blue

  i
    margin-right: 6px
    color: blue
  .light
    cursor: none !important
  &.light
    cursor: not-allowed
  &:hover
    color: rgba(0, 0, 0, 0.5)






h3
  font-size: 16px
  // font-size: 20px
  font-weight: 600
  letter-spacing: 0.02em


.omschrijving
  color: rgba(7, 41, 80, 0.8)
  font-size: 16px
  padding-top: 0.6em
  padding-bottom: 1.5em
  line-height: 1.5em
  font-weight: 400
  letter-spacing: 0.02em

.wrapper
  display: flex
  flex-direction: column
  h1
    padding: 14px 14px 14px
    font-weight: 600
    border-bottom: 1px solid rgba(0, 0, 0, 0.1)
  .top
    width: 100%
    padding: 20px 20px 0
    display: flex
    flex-direction: column

    .cdt_note
      flex-grow: 1
      width: 100%
      .left
        i
          transform: translateY(1px)
        span
          transform: translateY(-2px)


  .bottom
    display: flex
    flex-direction: row



    .left, .right
      // padding: 30px 0px
      padding: 30px 25px

    .right
      position: relative
      width: 100%
      // h3
        // padding: 0 30px
      > *
        // padding-right: 25px
        // padding-left: 25px


    .lineDivider
      width: 1px
      background-color: rgba(0, 0, 0, 0.1)
    .contactWrapper
      padding: 0 !important
      // background-color: pink
      position: absolute
      bottom: 30px
      left: 25px
      right: 25px
      display: flex
      .left1
        // background-color: yellow
        padding-right: 8px
      .right1
        padding-left: 8px
      .left1, .right1

        display: flex
        flex-direction: column
        // align-items: flex-start
        // justify-content: space-between
        // overflow: hidden
        width: 50%

        .item1
          justify-content: space-between
          display: flex
          margin-bottom: 6px
          // overflow: hidden


          span
            font-size: 13px
            font-weight: 600
            text-align: left
            // background-color: yellow
            min-width: 70%
          .light
            width: 40%
            opacity: .6
            font-weight: 400
            min-width: 30%
            max-width: 30%
            // background-color: blue




    .contactGegevens
      display: flex
      flex-direction: column
      padding-top: 20px
      *
        margin-bottom: 4px
      &:last-child
        margin-bottom: 0
      // padding: 10px
      // border-radius: 6px
      // border: 1px solid rgba(0, 0, 0, 0.08)

    .blue
      color: blue
      font-size: 14px
      font-weight: 400
      letter-spacing: 0.02em
      // padding: 6px 10px
      // background-color: rgba(0, 0, 0, 0.04)
      // border: 1px solid rgba(0, 0, 0, 0.12)
      max-width: fit-content
      border-radius: 10000px
      color: rgba(7, 41, 80, 0.8)
      i
        color: blue
        font-size: 14px
        margin-right: 6px
    .spacer
      width: 30px
</style>
